const schema = process.env.NODE_ENV === 'production' ? 'https' : 'http';

export const DOCUSIGN_INTEGRATION_KEY = process.env.VUE_APP_DOCUSIGN_INTEGRATION_KEY;
export const DOCUSIGN_HOST_NAME = process.env.VUE_APP_DOCUSIGN_HOST_NAME;
export const PEQUITY_BASE_URL = process.env.VUE_APP_PEQUITY_BASE_URL || 'localhost:8000';
export const PEQUITY_API_URL = `${schema}://${process.env.VUE_APP_PEQUITY_BASE_URL}/api`;
export const PEQUITY_SOCKETS_BASE_URL = process.env.VUE_APP_PEQUITY_SOCKETS_BASE_URL || PEQUITY_BASE_URL;
export const PEQUITY_SOCKET_PROTOCOL = process.env.NODE_ENV === 'production' ? 'wss' : 'ws';
